import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/modules/shared.module';
import { KcmCardComponent } from './kcm-card/kcm-card.component';

@NgModule({
  declarations: [KcmCardComponent],
  imports: [CommonModule, SharedModule],
  exports: [KcmCardComponent],
})
export class KcmModule {}
